<template>
  <section class="zones-slider">
    <div class="container">
      <ShadowTitle :title="`5 интерактивных зон <br>с актуальными темами от спикеров`"
                   title-shadow="INTERACTIVE"
      />
      <div class="swiper-container swiper-zones">
        <div :class="windowSize <= 768 ? 'swiper-wrapper' : 'zones-wrap'">
          <div :class="windowSize <= 768 ? 'swiper-slide' : 'zones-wrap-item'"
               v-for="(item, index) in zones"
               :key="`course-${index}`">
            <div class="zones-item"
                 :style="{ backgroundImage: `url(${item.image})`, backgroundSize: 'cover', backgroundRepeat: 'no-repeat' }">
              <div class="zones-item_text">{{ item.text }}</div>
            </div>
          </div>
        </div>
        <div class="swiper-pagination swiper-zones-pagination"></div>
      </div>
    </div>
    <div class="container d-none">
      <div class="join-banner">
        <div class="join-banner-head"/>
        <div class="join-banner-body">
          <div class="row">
            <div class="col-12">
              <div class="join-banner-title">
                Участвуют абсолютно все билеты
              </div>
            </div>
            <div class="col-12 col-md-6">
              <div class="join-banner-text">
                Приходи на мероприятие и участвуй <br>в розыгрыше тура в солнечную Турцию 5* All in, <br>а также других ценных подарков от ELS SPACE!
              </div>
            </div>
            <div class="col-12">
              <GlobalButton button-href="/pdf/tur-v-turtsiyu.pdf" class="join-banner-button">
                Хочу участвовать
              </GlobalButton>
            </div>
          </div>
        </div>
      </div>
    </div>
  </section>
</template>
<script>
import {nextTick, onMounted, onUnmounted, ref, watch} from 'vue';
import ShadowTitle from "@/components/ShadowTitle";
import GlobalButton from "@/components/GlobalButton";
import Swiper from 'swiper';
import {Pagination} from 'swiper/modules';
import 'swiper/swiper.css';

const zonesData = [
  {
    image: require('@/assets/zones/zone-1.png'),
    text: 'Конференц-зона',
  },
  {
    image: require('@/assets/zones/zone-2.jpeg'),
    text: 'Нетворкинг-зона',
  },
  {
    image: require('@/assets/zones/zone-3.png'),
    text: 'Релакс-зона',
  },
  {
    image: require('@/assets/zones/zone-4.png'),
    text: 'Зона трансформационных игр',
  },
  {
    image: require('@/assets/zones/zone-5.png'),
    text: 'Open talk-зона',
  },
];

export default {
  name: "ZonesSlider",
  components: {GlobalButton, ShadowTitle},
  setup() {
    const zones = ref(zonesData);
    const swiperInstance = ref(null);
    const windowSize = ref(window.innerWidth);

    const initializeSwiper = () => {
      nextTick(() => {
        if (windowSize.value <= 768) {
          if (!swiperInstance.value) {
            swiperInstance.value = new Swiper('.swiper-zones', {
              modules: [Pagination],
              pagination: {
                el: '.swiper-zones-pagination',
                clickable: true,
              },
              breakpoints: {
                0: {
                  slidesPerView: 1.1,
                  spaceBetween: 16
                },
                400: {
                  slidesPerView: 1.5,
                  spaceBetween: 16
                },
                500: {
                  slidesPerView: 2,
                  spaceBetween: 16
                },
                768: {
                  slidesPerView: 3,
                  spaceBetween: 16
                }
              }
            });
          }
        } else if (swiperInstance.value) {
          swiperInstance.value.destroy();
          swiperInstance.value = null;
        }
      });
    }

    const handleResize = () => {
      windowSize.value = window.innerWidth;
    };

    watch(windowSize, initializeSwiper);

    onMounted(() => {
      initializeSwiper();
      window.addEventListener('resize', handleResize);
    })

    onUnmounted(() => {
      window.removeEventListener('resize', handleResize);
    });

    return {
      zones,
      windowSize,
    }
  },
}

</script>
<style lang="scss" scoped>
@mixin wrap-css {
  width: 100%;
  margin-bottom: 16px;
  border-radius: 16px;
  overflow: hidden;
  position: relative;

  &:before {
    content: '';
    width: 100%;
    height: 100%;
    position: absolute;
    bottom: 0;
    right: 0;
    background: linear-gradient(180deg, rgba(0, 0, 0, 0.00) 62.61%, rgba(0, 0, 0, 0.90) 100%);
  }
}

.zones-slider {
  .swiper-slide {
    @include wrap-css();
  }
}

.zones-wrap {
  display: flex;
  @include _768 {
    flex-wrap: wrap;
    justify-content: space-between;
  }

  .zones-wrap-item {
    @include wrap-css();

    @include _576 {
      width: calc(50% - 8px);
    }

    @include _992 {
      width: calc(33.3% - 8px);
      &:nth-last-child(-n+2) {
        width: calc(50% - 8px);
      }
    }
  }
}

.zones-item {
  width: 100%;
  height: 357px;
  display: flex;
  justify-content: center;
  align-items: end;
  padding: 24px;

  .zones-item_text {
    font-size: 18px;
    font-style: normal;
    font-weight: 400;
    line-height: 136%; /* 31.28px */
    position: relative;
    z-index: 3;
    text-align: center;
    @include _768 {
      font-size: 23px;
      text-align: left;
    }
  }
}

.join-banner {
  border-radius: 16px;
  background: linear-gradient(66deg, #C0F 5.52%, #010BFE 193.94%);
  position: relative;
  overflow: hidden;
  margin-top: 60px;
  @include _768 {
    margin-top: 120px;

    &:after {
      content: '';
      width: 100%;
      height: 100%;
      position: absolute;
      top: 0;
      right: 0;
      background: url(~@/assets/zones/zones-join-in-2.png) no-repeat right center;
      background-size: contain;
      z-index: 1;
    }
  }

  .join-banner-head {
    border-radius: 16px;
    height: 200px;
    width: 100%;
    background: url(~@/assets/zones/zones-join-in.png) no-repeat center;
    background-size: cover;
    @include _768 {
      display: none;
    }
  }

  .join-banner-body {
    padding: 12px 16px 24px;
    position: relative;
    z-index: 2;
    display: flex;
    flex-direction: column;
    @include _768 {
      padding: 44px;
    }
  }

  .join-banner-title {
    font-family: Play, serif;
    font-size: 26px;
    font-style: normal;
    font-weight: 700;
    line-height: 138%;
    margin-bottom: 18px;
    @include _768 {
      font-size: 38px;
      margin-bottom: 12px;
    }
  }

  .join-banner-text {
    font-size: 18px;
    font-style: normal;
    font-weight: 400;
    line-height: 136%; /* 24.48px */
    margin-bottom: 32px;
    @include _768 {
      font-size: 20px;
      margin-bottom: 56px;
    }
  }

  .join-banner-button {
    font-size: 16px;
    padding-left: 12px;
    padding-right: 12px;
    margin-right: auto;
    display: inline-flex;
    @include _768 {
      font-size: 20px;
      padding: 16px 62px;
    }
  }
}
</style>